<template>
  <transition name="custom-classes-transition"
              enter-active-class="slide-fade-active"
              leave-active-class="slide-fade-leave-active">
    <div id="fixed-point-camera" v-show="isShow">
      <div>
        <feather-icon
          v-show="showIcon"
          :icon="cameraIcon"
          svgClasses="h-8 w-8 text-white"
        />
        <P>{{ cameraMsg }}</P>
      </div>
      <video-player
        id="fixed-point-camera-player"
        ref="videoPlayer"
        class="media-video-player card-video vjs-custom-skin"
        :options="playerOptions"
        @play="onPlayerPlay"
        @ready="onPlayerReady()"
        @error="onPlayerError"
      />
    </div>

  </transition>
</template>

<script>
import {videoPlayer} from "vue-videojs7";
import {createNamespacedHelpers} from "vuex";
import {AiseaApiFactory} from "@/api/aisea/apiFactory";
import {CAMERA_MOVIE_TYPE} from "@/config/const";

const cameraApi = AiseaApiFactory.get("enterpriseCamera")
import { DeviceInfoMixin } from "@/mixins";

// Store
const {
  mapMutations: mapMutationsOfLiveMap,
  mapState: mapStateOfLiveMap,
} = createNamespacedHelpers("liveMap");

export default {
  name: "FixedPointCameraSidebar",
  mixins: [DeviceInfoMixin],
  components: {
    videoPlayer
  },
  data() {
    return {
      isShow: false,
      showIcon: true,
      cameraIcon:"VideoIcon",
      cameraMsg: null,
      cameraInfo: null,
      playerOptions: {
        width: '352px',
        height: '200px',
        autoplay: true,
        responsive: true,
        loadingSpinner: false,
        errorDisplay: false,
        muted: true,
        preload: "auto",
        fullscreen: false,
        closeButton: true,
        bigPlayButton: false,
        controlBar: {
          volumePanel: false,
          muteToggle: false,
          remainingTimeDisplay: false,
          pictureInPictureToggle: false,
          playToggle: true,
          progressControl: {
            seekBar: false,
          }
        }
      },
      styleObject: {
        width: '352px',
        height: '200px'
      }
    }
  },
  watch: {
    selectedFixedPointCamera(val) {
      if (val === null) {
        this.player.reset();
        this.cameraInfo = null
        this.isShow = false
        this.hasError = false;
        this.cameraMsg = ""
        return
      }
      if (this.cameraInfo != null) {
        this.isShow = false
        this.cameraInfo = null
      } else {
        this.isShow = true
        this.cameraInfo = val
        if (this.player) {
          this.playVideo()
        }
      }
    }
  },
  computed: {
    ...mapStateOfLiveMap({
      selectedFixedPointCamera: state => state.selectedFixedPointCamera
    }),
    player() {
      if (typeof this.$refs.videoPlayer === "undefined") return null;
      return this.$refs.videoPlayer.player;
    }
  },
  methods: {
    ...mapMutationsOfLiveMap([
      "SET_SELECTED_FIXED_POINT_CAMERA",
    ]),
    onPlayerReady() {
      if (this.cameraInfo) {
        this.playVideo()
      }

      const closeButton = document.getElementById("fixed-point-camera").getElementsByClassName("vjs-close-button")
      closeButton[1].addEventListener('click', () => {
        if(this.player.isFullscreen()) {
          this.player.exitFullscreen();
          setTimeout( ()=> {
            this.SET_SELECTED_FIXED_POINT_CAMERA(null)
          }, 500);
        } else {
          this.SET_SELECTED_FIXED_POINT_CAMERA(null)
        }

      });
    },
    onPlayerPlay() {
      this.showIcon = false;
      this.cameraMsg = ""
    },
    onPlayerError() {
      this.showIcon = true;
      this.cameraIcon = "VideoOffIcon"
      this.cameraMsg = "未接続"
    },

    async playVideo() {
      this.showIcon = true;
      this.cameraIcon = "VideoIcon"
      this.cameraMsg = "接続中…"
      let source = await this.getSourceUrl()
      if(source) {
        const video = {
          withCredentials: false,
          type: 'application/x-mpegurl',
          src: source
        }
        this.player.src(video)
      } else {
        this.showIcon = true;
        this.cameraIcon = "VideoOffIcon"
        this.cameraMsg = "未接続"
      }

    },

    async getSourceUrl() {
      try {
        let res
        if(this.cameraInfo.cameraType === CAMERA_MOVIE_TYPE.HLS_CAMERA || this.cameraInfo.cameraType === CAMERA_MOVIE_TYPE.MEDIAMTX) {
          res = await cameraApi.connectHLS(this.cameraInfo.cameraId)
          if(res.status) {
            return res.data.url
          } else {
            return null;
          }
        } else {
          res = await cameraApi.connect(this.cameraInfo.cameraId)
          if(res.status) {
            return res.data.url + "/webcam/hls/stream.m3u8";
          } else {
            return null;
          }
        }
      } catch (e) {
        return null;
      }
    },

    setLoadingSpinner(isOn) {
      const spinner = document.getElementById("fixed-point-camera").getElementsByClassName("vjs-loading-spinner")
      if (isOn) {
        spinner[0].style.display = "";
      } else {
        spinner[0].style.display = "none";
      }
    }
  },

  created() {
    if(this.isIOS()) {
      this.playerOptions.width = "176px"
      this.playerOptions.height = "100px"
    }
  },

  mounted() {
    if(this.isIOS()) {
      const camera = document.getElementById("fixed-point-camera")
      camera.style.top = "50px"
    }
  }
}
</script>

<style lang="scss">

#fixed-point-camera {
  position: absolute;
  top: 10px;
  pointer-events: auto !important;

  .feather-icon {
    z-index: 5;
    position: absolute;
    top: 45%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  p {
    font-size: 12PX;
    position: absolute;
    top: 65%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    margin: 0;
    padding: 0;
    color: white;
    z-index: 5;
  }
}

.slide-fade-active {
  animation: slide-in .3s;
}

.slide-fade-leave-active {
  animation: slide-out .5s;
}

@keyframes slide-in {
  0% {
    transform: translateX(-30%);
    opacity: .1;
  }

  100% {
    transform: translateX(0%);
    opacity: 1;
  }
}

@keyframes slide-out {
  0% {
    transform: translateX(0%);
    opacity: 1;
  }

  100% {
    transform: translateX(-30%);
    opacity: 0;
  }
}

</style>
